import $ from 'jquery';
import 'tablesorter';

export default class UtilityTable {
	constructor() {
		this.sortButton = $('.utility-table__titleCell_button');
	}

	init() {
		this.sortButton.on('click', function (event) {
			event.preventDefault();
			$(this).siblings().removeClass('utility-table__titleCell_button_active');
			$(this).addClass('utility-table__titleCell_button_active');
			$(this).siblings().find('.utility-table__icon-wrapper').removeClass('utility-table__icon-wrapper_active');
			$(this).find('.utility-table__icon-wrapper').addClass('utility-table__icon-wrapper_active');
		});

		$(document).ready(function () {
			$('#utility-table').tablesorter();
		});
	}
}



// WEBPACK FOOTER //
// ./app/blocks/utility-table/index.js